<template>
  <div class="images" v-if="hideImages">
    <button class="d-block btn btn-dark m-2" @click.prevent="closeImages">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle"
        viewBox="0 0 16 16">
        <path fill-rule="evenodd"
          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
      </svg>
      Grupo de formas
    </button>
    <img v-for="imageForm in images" :key="imageForm.id" :src="serverUrl + 'images/forms/' + imageForm.imgFile"
      class="img-responsive m-2 col-sm" :alt="imageForm.imageName"
      v-on:click="getImageInfo(imageForm.id, imageForm.imgFile)" style="min-width: 420px; max-height: 420px;" />
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  props: ["useFamilyId"],
  data() {
    return {
      images: [],
      serverUrl: RUTA_SERVIDOR,
      rawMatMainFamily: "",
    };
  },
  methods: {
    closeImages() {
      this.$emit("goBack");
    },
    async getImageInfo(imageId, imageFile) {
      this.rawMatMainFamily = this.$store.getters.getRawMatFamily;
      //console.log("RawMaterialFamily:" + this.rawMatMainFamily);
      // console.log(imageId);
      // console.log(imageFile);
      // this.$store.state.imgId = imageId;
      this.$store.dispatch("setImgIdAction", imageId);
      this.$store.dispatch("setImgFileAction", imageFile);
      if (this.rawMatMainFamily == "ACERO_CARBONO" || this.rawMatMainFamily == "INOXIDABLE" || this.rawMatMainFamily == "ALUMINIO" || this.rawMatMainFamily == "ANTIDESGASTE") {
        this.$router.push("/SheetImgQuote");
      } else if (this.rawMatMainFamily == "CANAL_U" || this.rawMatMainFamily == "VIGA_I" || this.rawMatMainFamily == "VIGA_H" || this.rawMatMainFamily == "ANGULO") {
        this.$router.push("/ProfileQuote")
      } else if (this.rawMatMainFamily == "ESTRUCTURAL" || this.rawMatMainFamily == "MUEBLE") {
        this.$router.push("/TubeQuote");
      } else {
        console.log("Raw Material Family not found, check and try again!")
      }
    },
  },
  beforeMount() {
    //console.log(RUTA_SERVIDOR);
    //console.log(this.useFamilyId);
    if (this.useFamilyId >= 1 && this.useFamilyId < 9) {
      axios
        .get(RUTA_SERVIDOR + "api/sheet/image/list", {
          params: {
            sheetImgFamily: this.useFamilyId,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        // .then((res)=>console.log(res.data))
        .then((res) => (this.images = res.data))
        .catch((err) => console.log(`There has been an error ${err}`));
    } else if (this.useFamilyId >= 9 && this.useFamilyId < 13) {
      axios
        .get(RUTA_SERVIDOR + "api/profile/image/list", {
          params: {
            profileImgFamily: this.useFamilyId,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        // .then((res)=>console.log(res.data))
        .then((res) => (this.images = res.data))
        .catch((err) => console.log(`There has been an error ${err}`));
    } else if (this.useFamilyId >= 13 && this.useFamilyId < 16) {
      axios
        .get(RUTA_SERVIDOR + "api/tube/image/list", {
          params: {
            tubeImgFamily: this.useFamilyId,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        // .then((res)=>console.log(res.data))
        .then((res) => (this.images = res.data))
        .catch((err) => console.log(`There has been an error ${err}`));
    } else {
      console.log("ImgGroupFamily by id don´t exists!")
    }
    this.hideImages = true;
  },
};
</script>
<style scoped>
.images {
  background-color: rgba(217, 217, 234, 0.3);
  border: solid 1px;
  border-radius: 10px;
  margin: 5px;
}

.btnClose {
  float: right !important;
}
</style>